export default __webpack_public_path__ + "static/media/vehicle.f92c411e.svg";